import { Modal } from 'react-bootstrap';
import { useState, useEffect } from "react";
import { validateField, isNumber } from "../../utils/validators";
import { FloatingTextInput } from "../reusable-elements/floating-text-input";
import Comparer from "../../app/comparer";
import DateTimePicker from '../calendar/datetime-picker';
import { ReasonSelector } from './reason-selector';

export const NewPeriodModal = ({ tenant, tenancy, setTenant, show, cancel, period }) => {

    const comparer = new Comparer();

    const defaultPeriod = {
        period: {
            start: new Date(),
            end: null, // Rolling
            moveToStartAndEndOfDays: true
        },
        rentalValue: 0,
        reason: 'rentChange'
    };

    const [newPeriod, setNewPeriod] = useState(defaultPeriod);
    const [validationErrors, setValidationErrors] = useState(null);
    const [openStartDtp, setOpenStartDtp] = useState(false);
    const [openEndDtp, setOpenEndDtp] = useState(false);
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        if (!!period) {
            setNewPeriod(period);
        }
    }, [period]);


    const validateState = newState => {
        // Validate fields that the user can change and that you care about the contents of
        validateField(() => isNumber(newState.rentalValue) && newState.rentalValue > 0, () => newState.rentalValue, setValidationErrors);
    };

    const handleStateUpdates = updateMethod => {
        setNewPeriod(current => {
            const newState = updateMethod(current);
            validateState(newState);
            setRerender(!rerender);
            return newState;
        });
    };

    const hasChanges = () => {
        const equal = comparer.equals(newPeriod, defaultPeriod);
        return !equal;
    };

    const canSave = () => {
        return hasChanges() && Object.keys(validationErrors ?? {}).length === 0;
    };

    const localHandleSave = () => {
        const existingTenancy = tenant.tenancies.find(t => t === tenancy);

        // Get the current date

        // Create a Date object with specific UTC time

        const startSeed = newPeriod.period.start = new Date(newPeriod.period.start);
        const startDate = new Date(Date.UTC(startSeed.getFullYear(), startSeed.getMonth(), startSeed.getDate(), 0, 0, 0, 0));

        // Create a new date object to avoid mutating the original date

        newPeriod.period.start = startDate.toISOString();

        if (!!!period) {
            const endSeed = newPeriod.period.end ? new Date(newPeriod.period.end) : null;

            const endDate = endSeed ?
                new Date(Date.UTC(endSeed.getFullYear(), endSeed.getMonth(), !!!period ? endSeed.getDate() - 1 : endSeed.getDate(), 23, 59, 59, 999)) :
                new Date(Date.UTC(startSeed.getFullYear(), startSeed.getMonth(), startSeed.getDate(), 23, 59, 59, 999));

            if (!endSeed) {
                endDate.setDate(endDate.getDate() - 1);
            }

            for (const period of existingTenancy.rentalPeriods) {
                if (typeof period.period.end === "object") {
                    period.period.end = endDate.toISOString();
                }
                else if (typeof period.period.end === "string") {
                    period.period.end ??= new Date(period.period.end).toISOString();
                }
            }
            existingTenancy.rentalPeriods.push(newPeriod);
        }
        else {
            const existingPeriodIndex = existingTenancy.rentalPeriods.findIndex(rp => rp === period);
            if (newPeriod.period && newPeriod.period.end) {
                newPeriod.period.end = newPeriod.period.end.toISOString();
            }

            existingTenancy.rentalPeriods[existingPeriodIndex] = newPeriod;
        }

        setTenant(structuredClone(tenant));
        setNewPeriod(null);
        cancel();
    };

    const localHandleCancel = () => {
        setNewPeriod(null);
        cancel();
    };

    return newPeriod && (
        <Modal
            show={show}
            onHide={localHandleCancel}
            backdrop="static"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Period</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ReasonSelector
                    onReasonSelected={newValue => { handleStateUpdates(v => { v.reason = newValue; return v; }) }}
                    selectedReason={newPeriod.reason}
                />

                <DateTimePicker
                    className={"mt-10px w-100"}
                    fetchComplete={true}
                    openDtp={openStartDtp}
                    showTime={false}
                    dateValue={newPeriod.period.start}
                    placeholder={`${!newPeriod.period.start ? "Select" : ""} Start Date`}
                    stopEditDate={() => setOpenStartDtp(false)}
                    setDate={newValue => { handleStateUpdates(v => { v.period.start = newValue; return v; }) }}
                    editDate={() => setOpenStartDtp(true)}
                />

                {!!period && <DateTimePicker
                    className={"mt-10px w-100"}
                    fetchComplete={true}
                    openDtp={openEndDtp}
                    showTime={false}
                    dateValue={newPeriod.period.end}
                    placeholder={`${!newPeriod.period.end ? "Select" : ""} End Date`}
                    stopEditDate={() => setOpenEndDtp(false)}
                    setDate={newValue => { handleStateUpdates(v => { v.period.end = newValue; return v; }) }}
                    editDate={() => setOpenEndDtp(true)}
                />}

                <FloatingTextInput
                    className={"mt-1"}
                    label={`${!newPeriod.rentalValue ? "Enter" : ""} Rent Amount`}
                    text={newPeriod.rentalValue}
                    updateCallback={newValue => { handleStateUpdates(v => { v.rentalValue = parseFloat(newValue); return v; }) }}
                    validatorFn={() => { return isNumber(newPeriod.rentalValue) }}
                    readOnly={false}
                />

            </Modal.Body>
            <Modal.Footer>
                <div className='btn-group'>
                    <button disabled={!canSave()} className='btn btn-primary' onClick={localHandleSave}>
                        Save
                    </button>
                    <button className='btn btn-secondary' onClick={localHandleCancel}>
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );

};